import {
  Box,
  Divider,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { FindInPageOutlined } from "@mui/icons-material"
import { useCallback, useMemo } from "react"
import { ID_CABO } from "src/components/componentes/types";
import { VALOR_MULTIPLO_CABO } from "src/components/projetos/constants"
import { MENSAGEM_QUANTIDADE_CABOS_INVALIDA } from "src/constants"
import { PermissionUtil } from "src/framework/commons/PermissionUtil"
import InputQuantidade from "src/framework/components/forms/inputs/InputQuantidade"
import { useProjetosOffGridStore } from "src/store/vendas/projetos/offgrid.store"
import { modalComponentesDetalhesData$ } from "src/store/vendas/projetos/store"

const useStyles = makeStyles({
  itemContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: '8px 16px 8px 16px'
  },
  boxNomeItem: {
    flexDirection: 'row',
    display: 'flex',
    justifyContent: 'start',
    fontSize: "12px",
  },
  headerInfo: {
    color: "#f59e0b",
    fontSize: "12px"
  },
  textoInfo: {
    color: "#6a7282",
    fontSize: "10px",
    paddingLeft: "5px"
  },
  infoRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  boxQuantidadeDados: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space_between",
    alignItems: "center",
    width: "100%",
  },
  boxQuantidade: {
    width: "55%",
    marginLeft: "-25px"
  },
  boxDados: {
    width: "20%",
  },
  emptyBox: {
    width: "30%"
  }
  
})

const DadosTecnicosCellMobile = ({ componente }: { componente: { componente_id: number | null | undefined } }) => {
  return (
    <Box display={"flex"} alignItems="center" justifyContent={"center"}>
      <IconButton
        onClick={e => {
          e.stopPropagation();
          if (componente?.componente_id) {
            modalComponentesDetalhesData$.next(componente.componente_id)
          }
        }}
        size="large">
          <FindInPageOutlined htmlColor="black" />
      </IconButton>
    </Box>
  );
}

interface ItemSolucaoMobileProps {
  item: any;
  tipo_componente: "acessorios" | "estruturas" | "itens_solucao" | "modulos";
  disabledQuantidade?: boolean;
  handleChangeModulo?: (moduloId: number) => void;
}

export const ItemSolucaoMobile = ({ tipo_componente, item, disabledQuantidade, handleChangeModulo }: ItemSolucaoMobileProps) => {
  const { acessorios, estruturas_calculadas } = useProjetosOffGridStore(store => store.state.data)
  const { changeValue: changeStoreValue } = useProjetosOffGridStore(store => store.actions)
  const permissoes = PermissionUtil.getPermissions();

  const temPermissaoCodigoComponente = useMemo(()=>{
      return PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_CODIGO_COMPONENTE, permissoes)
  },[permissoes])
  const classes = useStyles();
  const nomeComponente = temPermissaoCodigoComponente ? `${item.componente_id} - ${item.nome}` : item.nome;
  
  const checkError = useCallback((categoriaId: number, qtd: number): boolean => {
    if (categoriaId !== ID_CABO) {
      return false;
    }
    if (qtd === 0) {
      return false;
    }
    if (qtd % 25 === 0) {
      return false;
    }
    return true
  },[])

  const onChangeQuantidade = useCallback((componente_id: number,value: number, tipo_componente: "acessorios" | "estruturas" | "itens_solucao" | "modulos") => {
      switch (tipo_componente) {
        case "acessorios":
          const newAcessorios = acessorios.map(item => {
            if (item.componente_id === componente_id) {
              return { ...item, quantidade: value }
            }
            return item;
          })
          changeStoreValue({ acessorios: newAcessorios })
          break;
        case "estruturas":
          const newEstruturas = estruturas_calculadas.map(item => {
            if (item.componente_id === componente_id) {
              return { ...item, quantidade: value }
            }
            return item;
          })
          changeStoreValue({ estruturas_calculadas: newEstruturas })
          break;
        case "itens_solucao":
          break;
      }
    }, [acessorios, changeStoreValue, estruturas_calculadas])

  return (<>
    <Box className={classes.itemContainer}>
        <Box textAlign="left" className={classes.boxNomeItem}>
            {/* nome e codigo*/}
            {tipo_componente === "modulos" && (
              <RadioGroup
                row
                aria-labelledby="demo-radio-buttons-group-label"
                value={null}
                name="radio-buttons-group"
                onChange={(e: any) => {
                  if(handleChangeModulo){
                    handleChangeModulo(Number(e.target.value))
                  }
                }}
              >
                <FormControlLabel value={item.componente_id} control={<Radio style={{color: "green"}}/>} label="" />
              </RadioGroup>
            )}
            <Typography>{nomeComponente}</Typography>
        </Box>
        <Box textAlign="left" className={classes.infoRow}>
          {/* informações */}
          <Typography className={classes.headerInfo}>Informações: </Typography>
          <Typography className={classes.textoInfo}>{item?.descricao}</Typography>
        </Box>
        <Box className={classes.boxQuantidadeDados}>
          {/*quantidade e detalhes*/}
          <Box className={classes.boxQuantidade}>
            <InputQuantidade disabled={disabledQuantidade || false} multiple={item.categoria_componentes_id === ID_CABO ? VALOR_MULTIPLO_CABO : 1} value={item.quantidade} highlightField={false} onChange={(v: number) => onChangeQuantidade(item.componente_id, v, tipo_componente)} hasError={checkError(item.categoria_componentes_id, item.quantidade)}/>
            {item.categoria_componentes_id === ID_CABO && checkError(item.categoria_componentes_id, item.quantidade) && (
              <Typography style={{ color: "#b91322", fontSize: "8px", marginLeft: "16px", width: "100%"}}>{MENSAGEM_QUANTIDADE_CABOS_INVALIDA}</Typography>
            )}
          </Box>
          <Box className={classes.emptyBox}></Box>
          <Box className={classes.boxDados}>
            <DadosTecnicosCellMobile componente={{ componente_id: item?.componente_id || null }} />
          </Box>
        </Box>
        <Divider style={{marginTop: "10px", marginBottom: "5px"}}/>
    </Box>
  </>
  )
}
